import _get from 'lodash/get';

import { objectToCamelCase } from 'libs/format';

export function selectStyleRules(state) {
  return objectToCamelCase(_get(state, 'website.styleRules.value'));
}
